export const getCookiesGroups = (groupsData, value) =>
    Object.keys(groupsData).reduce((obj, key) => ({ ...obj, [key]: value }), {});
